
import { Dispatch } from 'redux';
import { TableColumnWidthInfoGeneric } from './types';
import { setColumnSizeAction } from './actions';
export function setSize(key: string,columnWidths: Array<TableColumnWidthInfoGeneric<string>>) {
	return async (dispatch: Dispatch<any>) => {
		dispatch(setColumnSizeAction({key,data:columnWidths}));
	};
}